<template>
  <v-card flat class="mb-7 w-100">
    <v-card-text class="pa-5">
      <div class="d-md-flex align-start">
        <div class="d-flex flex-column ml-3">
          <h3 class="title font-weight-regular">Códigos inscritos</h3>
          <h5>Datos de códigos inscritor</h5>
        </div>
        <v-spacer></v-spacer>
        <div class="ml-auto d-flex justify-end"></div>
      </div>

      <div class="pa-3 pt-5" style="max-width: 420px;">
        <v-text-field
          v-model="searchLocal"
          prepend-inner-icon="mdi-magnify"
          dense
          outlined
          clearable
          hide-details
          label="Buscar código, descuento o cantidades"
        />
      </div>
      <v-data-table
        :headers="headerArray"
        :items="displayCodes"
        hide-default-footer
        :page.sync="page"
        @page-count="pageCount = $event"
        :items-per-page="10"
      >
        <template v-slot:item.activo="{ item }">
          <div class="d-flex justify-end">
            <v-switch v-model="item.activo" @click="changeStateOfCode(item)" class="pa-0"/>
          </div>
        </template>
        <template v-slot:item.codigo="{ item }">
          <div
            class="d-flex"
            style="cursor: pointer;"
            @click="$router.push({ name: 'CodeDetail', params: { id: item.id } })"
          >
            <div class="my-auto">
              <h4 class="font-weight-medium text-no-wrap">
                {{ item.codigo }}
              </h4>
            </div>
          </div>
        </template>
        <template v-slot:no-data>
          <div class="text-center pa-6">
            No se encontraron códigos con “{{ searchLocal }}”.
          </div>
        </template>
      </v-data-table>
      <v-pagination
        v-model="page"
        :length="pageCount"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import axios from 'axios'
import { mapState, mapActions } from 'vuex'

export default {
  name: "TheCodeDataTable",
  data: () => ({
    page: 1,
    pageCount: 0,
    switch1: true,
    select: { state: "Febrero", abbr: "FL" },
    items: [
      { state: "Enero", abbr: "FL" },
      { state: "Febrero", abbr: "GA" },
      { state: "Marzo", abbr: "NE" },
      { state: "Abril", abbr: "CA" },
    ],
    headerArray: [
      { text: 'Código', value: 'codigo', sortable: true, align: 'start' },
      { text: 'Matrículas concretadas', value: 'cantidad_matriculas', sortable: true, align: 'start' },
      { text: 'Formularios llenados', value: 'cantidad_formularios', sortable: true, align: 'start' },
      { text: 'Descuento', value: 'porcentaje_descuento', sortable: true, align: 'start' },
      { text: 'Activo', value: 'activo', sortable: true, align: 'end' }
    ],
    searchLocal: ''
  }),
  computed: {
    ...mapState(['codes']),
    // Lista filtrada localmente
    displayCodes () {
      const list = Array.isArray(this.codes) ? this.codes : []
      const q = (this.searchLocal || '').toString().trim().toLowerCase()
      if (!q) return list
      return list.filter(c => {
        const codigo = (c.codigo ?? '').toString().toLowerCase()
        const desc   = (c.porcentaje_descuento ?? '').toString().toLowerCase()
        const mats   = (c.cantidad_matriculas ?? '').toString().toLowerCase()
        const forms  = (c.cantidad_formularios ?? '').toString().toLowerCase()
        return (
          codigo.includes(q) ||
          desc.includes(q)   ||
          mats.includes(q)   ||
          forms.includes(q)
        )
      })
    }
  },
  methods: {
    ...mapActions(['fetchCodes']),
    async changeStateOfCode (item) {
      await axios.patch(`api/admin/matriculas/codigos_referencia/${item.id}/`, {
        activo: item.activo
      })
    }
  },
  watch: {
    '$store.state.reload': function () {
      this.fetchCodes()
    }
  },
  async created () {
    await this.fetchCodes()
  }
}
</script>